import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedProjects } from '@hooks/mocks/projects'
import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

interface IProjects {
  code: string
  description: string
  id: number
  isActive: boolean
}

export const useFindSiteProjects = () => {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  const fetchSiteProjects = async () => {
    if (!isMockEnvironment) {
      const url = `sites/${siteId}/projects`
      const { data } = await api.get<IProjects[]>(url)
      return data
    }
    return mockedProjects
  }
  return useQuery({ queryKey: ['PROJECTS'], queryFn: fetchSiteProjects })
}
